"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TimezonePicker_1 = require("./TimezonePicker");
exports.TIMEZONES = {
    "GMT-12 - NST - New Zealand Standard Time": "Etc/GMT+12",
    "GMT-11 - MIT - Midway Islands Time": "Etc/GMT+11",
    "GMT-10 - HST - Hawaii Standard Time": "Etc/GMT+10",
    "GMT-9 - AST - Alaska Standard Time": "Etc/GMT+9",
    "GMT-8 - PST - Pacific Standard Time": "Etc/GMT+8",
    "GMT-7 - PNT - Phoenix Standard Time": "Etc/GMT+7",
    "GMT-6 - CST - Central Standard Time": "Etc/GMT+6",
    "GMT-5 - EST - Eastern Standard Time": "Etc/GMT+5",
    "GMT-4 - PRT - Puerto Rico and US Virgin Islands Time": "Etc/GMT+4",
    "GMT-3 - AGT - Argentina Standard Time": "Etc/GMT+3",
    "GMT-2 - BET - Brazil Eastern Time": "Etc/GMT+2",
    "GMT-1 - CAT - Central African Time": "Etc/GMT+1",
    "GMT-0 - GMT - Greenwich Mean Time": "Etc/GMT+0",
    "GMT+1 - ECT - European Central Time": "Etc/GMT-1",
    "GMT+2 - EET - Eastern European Time": "Etc/GMT-2",
    "GMT+3 - EAT - Eastern African Time": "Etc/GMT-3",
    "GMT+4 - NET - Near East Time": "Etc/GMT-4",
    "GMT+5 - PLT - Pakistan Lahore Time": "Etc/GMT-5",
    "GMT+6 - BST - Bangladesh Standard Time": "Etc/GMT-6",
    "GMT+7 - VST - Vietnam Standard Time": "Etc/GMT-7",
    "GMT+8 - CTT - China Taiwan Time": "Etc/GMT-8",
    "GMT+9 - JST - Japan Standard Time": "Etc/GMT-9",
    "GMT+10 - AET - Australia Eastern Time": "Etc/GMT-10",
    "GMT+11 - SST - Solomon Standard Time": "Etc/GMT-11",
    "GMT+12 - NST - New Zealand Standard Time": "Etc/GMT-12"
};
function selectedLabelFormatter(label) {
    return label.slice(0, label.lastIndexOf(" - "));
}
exports.TimeZonesList = (function (list) { return Object.keys(list).map(function (key) { return ({ label: key, value: list[key] }); }); })(exports.TIMEZONES);
var TimezonePicker = TimezonePicker_1.default(exports.TimeZonesList, selectedLabelFormatter);
exports.TimezonePicker = TimezonePicker;
exports.default = TimezonePicker;
